<div class="login-container">
  <div class="left-side">
    <div class="content-wrapper">
      <div class="message">
        <h1 *ngIf="currentStep === 'email'">Login Quickly with OTP Code</h1>
        <h1 *ngIf="currentStep === 'otp'">Login Quickly with OTP Code</h1>
      </div>
      <div class="image-wrap">
        <img src="assets/images/forgot-illustration.png" alt="Illustration of a user logging in" class="welcome-image">
      </div>
    </div>
  </div>

  <div class="right-side">
    <div class="login-form-wrapper">
      <div class="logo-wrapper">
        <img src="assets/images/upspl_log.png" alt="Company Logo" class="logo" />
      </div>
      <div *ngIf="successMessage" class="success-banner" role="alert" aria-live="polite">{{ successMessage }}</div>
      <div *ngIf="errorMessage" class="error-banner" role="alert" aria-live="polite">{{ errorMessage }}</div>

      <ng-container *ngIf="currentStep === 'email'">
        <div class="form-header">
          <p class="login-title">Login Quickly with OTP Code</p>
          <p class="login-subtitle">Enter your work email or mobile number</p>
        </div>
        <form class="login-form" (ngSubmit)="onSubmitEmail()" [formGroup]="emailForm">
          <div class="form-group">
            <label for="email" class="form-label">Email Address or Mobile Number</label>
            <input 
              type="text"
              id="email" 
              formControlName="email" 
              placeholder="Enter email or 10-digit mobile number"
              autocomplete="username"
              class="form-control" 
            />
            <div *ngIf="emailForm.get('email')?.invalid && (emailForm.get('email')?.dirty || emailForm.get('email')?.touched)" class="error">
              <div *ngIf="emailForm.get('email')?.errors?.['required']">Email address or mobile number is required.</div>
              <div *ngIf="emailForm.get('email')?.errors?.['emailOrMobile']">Enter a valid email address or 10-digit mobile number.</div>
            </div>
          </div>
          <button type="submit" class="btn btn-send" [disabled]="isResendDisabled || isLoading">
            Send{{ isLoading ? 'ing...' : '' }}
          </button>
        </form>
      </ng-container>

      <ng-container *ngIf="currentStep === 'otp'">
        <div class="form-header">
          
          <p class="login-title">Enter the {{ otpLength }}-digit code sent to {{email}} to continue.</p>
        </div>
        <form class="login-form" (ngSubmit)="onSubmitOtp()" [formGroup]="otpForm">
          
          <div class="form-group">
            <label for="otp" class="form-label">OTP</label>
            <input 
              type="text" 
              id="otp" 
              formControlName="otp" 
              [placeholder]="'Enter ' + otpLength + '-digit code'"
              inputmode="numeric"
              [attr.maxlength]="otpLength"
              class="form-control" 
            />
            <div *ngIf="otpForm.get('otp')?.invalid && (otpForm.get('otp')?.dirty || otpForm.get('otp')?.touched)" class="error">
              <div *ngIf="otpForm.get('otp')?.errors?.['required']">OTP is required.</div>
              <div *ngIf="otpForm.get('otp')?.errors?.['pattern']">OTP must be a {{ otpLength }}-digit number.</div>
            </div>
          </div>
          <div class="resend-link">
            <a (click)="resendOtp()" class="resend" [class.disabled]="isResendDisabled">
              Didn't get it? Resend OTP{{ isResendDisabled ? ' (wait ' + resendCountdown + 's)' : '' }}
            </a>
          </div>
          <button type="submit" class="btn btn-verify" [disabled]="otpForm.invalid || isLoading">
            Verify{{ isLoading ? 'ing...' : '' }}
          </button>
        </form>
      </ng-container>
    </div>
  </div>
</div>
